module.exports = __webpack_public_path__ + "img/step3.43cf0417.png";